import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import {serviceURL} from '../../../util/uiconstants';
import utilityfunctions from '../../../util/utilityfunctions';
import OutputText from '@ey/canvascoreservices/OutputText';
import ClientsTable from './ClientsTable';
import ProjectOwner from './ProjectOwner';
import { clientEngagementsSelector, selectedClientsSelector } from './Helper/dataSelector';
import * as projectActionTypes from '../CreateProjectClassic/Helper/projectActionTypes';
import { ProjectContext } from './Helper/context';
import selectAllClients from '../../../reducers/Clients/selectors/selectAllClients';
import { getClientEngagements } from '../../../actions/Engagement/engagementactions';
import { useDispatch, useSelector } from 'react-redux';
import env from '../../../util/env';
import EntityTreeViewComponents from './EntityTreeViewComponents';

const CreateProjectStep4 = (props) => {
	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const project = useSelector((state) => state.newProject);
	const allClients = useSelector(selectAllClients);
	let selectedClients = selectedClientsSelector();
	let { clientEngagements } = clientEngagementsSelector(props, { showAll: true });
	const globalDispatch = useDispatch();
	//Context
	const { dispatch } = useContext(ProjectContext);
	const [projectOwners, setProjectOwners] = useState([]);
	// On click of edit icon, show modal. Also save the step where user wants to go and edit
	const handleEditIconClick = (step) => {
		props.setShowWarningForBack(true);
		props.setNavigateToSpecificStep(step);
	};

	useEffect(() => {
		if (isEditMode) {
			if (allClients.length > 0 && selectedClients.length === 0) {
				dispatch({
					type: projectActionTypes.UPDATE_SELECTED_CLIENTS,
					payload: { clients: project.clients }
				});
			}
		}
	}, [allClients]);

	useEffect(() => {
		if (clientEngagements && props.nodes) {
			let availableEngagements = [];
			if (!_.isEmpty(clientEngagements)) {
				clientEngagements.forEach((eng) => availableEngagements.push(eng.canvasEngagementId));

				let updatedNodes = props.nodes.map((n) => {
					// let nodeEngagements = n.engagements.filter((engagement) => availableEngagements.includes(engagement));
					// if (n.engagements.length > 0 && nodeEngagements.length === 0) {
					// 	nodeEngagements=[...n.engagements]
					// } 
					let updatedNode = {
						...n,
						engagements: n.engagements,
						engagementLabel: labels.connectedToEngagements(n.engagements.length)
					};
					return updatedNode;
				});
				props.setNodes(updatedNodes);
			}
		}
	}, [clientEngagements]);

	useEffect(() => {
		if (_.isEmpty(clientEngagements) && !_.isEmpty(selectedClients) && selectedClients[0].source) {
			const url = `${env.getBaseURL(serviceURL)}ClientEngagements`;
			let canvasEngagements = [];
			const canvasClients = selectedClients
				.filter((client) => client.source.indexOf('EY Canvas') > -1)
				.map((client) => client.clientCode);
			allClients.forEach((client) => {
				// sometime value of client.engagementIds[0] is null
				if (canvasClients.indexOf(client.clientCode) !== -1 && client.engagements.length > 0 && client.engagements[0]) {
					canvasEngagements.push(...client.engagements);
				}
			});
			const independenceEntityIds = [];
			const independenceClients = selectedClients.filter((client) => client.source.indexOf('Independence') > -1);
			_.forEach(independenceClients, (x) => {
				if (x.entityIds) {
					independenceEntityIds.push(...x.entityIds);
				}
			});
	
			// Get the engagement details for which details are not available and which are in connected list
			const connectedEngagementIds = [];
			const universalEngagementIds = [];
			_.forEach(project?.orgStructure, (x) => {
				if (x.engagements) {
					connectedEngagementIds.push(...x.engagements);
				}
			});
			_.forEach(canvasEngagements, (x) => {
				if (x.canvasEngagementId) {
					universalEngagementIds.push(x.canvasEngagementId);
				}
			});
			const engagementIds = connectedEngagementIds.filter((x) => !universalEngagementIds.includes(x));
	
			const body = {
				financial: selectedClients
					.filter((client) => client.source.indexOf('Financial') > -1)
					.map((client) => client.clientCode),
				Independence: independenceEntityIds,
				canvasEngagements: engagementIds,
				projectId: project && project.Id ? project.Id : project?.id
			};
	
			const payload = {
				canvasEngagements: canvasEngagements
			};
	
			globalDispatch(getClientEngagements(url, body, payload))
				.then(() => {})
				.catch(() => {});
		}
	}, [selectedClients]);

	const assaignProjectOwners = (projectOwners) => {
		setProjectOwners(projectOwners);
	}

	return (
		<StyledStep5Section className="step4">
			<div className="header-content">
				<OutputText h4>{labels.step5InstructionHeader}</OutputText>
				<OutputText light>{utilityfunctions.createRichTextElement(labels.step5SubInstruction)}</OutputText>
			</div>
			<section className="table-container">
				<section className="access-grp-table">
					<ProjectOwner handleEditIconClick={handleEditIconClick} assaignProjectOwners={assaignProjectOwners} />

				</section>
				<section className="clients-table">
					<ClientsTable project={project} handleEditIconClick={handleEditIconClick} />
				</section>
			</section>
			<section className="chart-section">
				<EntityTreeViewComponents nodes={props.nodes} handleEditIconClick={handleEditIconClick} project={project} clientEngagements={clientEngagements} projectOwners={projectOwners} />
			</section>
		</StyledStep5Section>
	);
};

export default CreateProjectStep4;

const StyledStep5Section = styled.section`
	.header-content {
		display: flex;
		flex-direction: column;
	}
	.chart-heading {
		display: flex;
		padding: 0 1.5rem;
		height: 3rem;
		justify-content: space-between;
		align-items: center;
		background-color: var(--neutrals-25);
		.left-section {
			display: flex;
			gap: var(--px-10);
		}
		.motif-icon{
			svg{
				fill: ${(props) => props.theme.color[`grey400`]};
			}
		}
	}

	.chart-section {
		margin: 2rem 0;
		width: 99%;
	}

	.table-container {
		display: flex;
		width: 99%;
		justify-content: space-between;
	}
	.access-grp-table {
		max-width: 35%;
		width: 35%;
	}

	.clients-table {
		max-width: 63%;
		width: 63%;

		.expand-icon{
			transform: rotate(45deg);
		}
	}

	.clients-table,
	.access-grp-table {
		.motif-card{
			border: solid 1px ${(props) => props.theme.color[`grey300`]};
			border-radius: 0.8rem;

			.table-header{
				background-color: ${(props) => props.theme.color[`grey100`]};
				border-bottom: solid 1px ${(props) => props.theme.color[`grey300`]};
				padding: 0 2rem;
				border-top-left-radius: 0.8rem;
    			border-top-right-radius: 0.8rem;

				.table-header-col-0,
				table-header-col-1,
				.sort-label{
					font-size: 1.4rem;
					font-weight: normal;
				}
				.motif-icon{
					svg{
						fill: ${(props) => props.theme.color[`grey400`]};
					}
				}
			}
			.table-body,
			.list-body{
				border-bottom-left-radius: 0.8rem;
    			border-bottom-right-radius: 0.8rem;
			}
		}
		.list-body {
			height: 19rem;
			.table-row{
				padding: 0 2rem;
				border-bottom: solid 1px ${(props) => props.theme.color[`grey225`]}
			}
		}
	}

	.boc-toolbar-container {
		left: var(--px-18);
		top: var(--px-18);
		display: flex;
		flex-direction: column;
		width: 4rem;
	}
`;

const StyledModalBodySection = styled.section`
	padding: 1rem 2rem;
`;
